function updateInsurance(cart) {

    console.log('update insurance price');
    console.log(cart);
    console.log(cart.items);

    

    $('.sm--cart-disable').addClass('sm--loading');

    var insurance_percentage = 0.15;

    var hair_price = 0;
    var insurance_id = 0;
    var insurance = {};
    if(cart.items) {

        // Triggered when changing the quantity and we have the whole cart
        $.each(cart.items, function(index, item) {

            if(item.product_type == 'hair') {
                hair_price += (item.quantity * item.price);
            }

            if(item.product_type == 'insurance') {
                insurance_id = item.product_id;
                insurance = item;
            }

        });

    } else {

        // Triggered when adding a new product and we have only the product
        console.log('adding new product to the cart');
        console.log(CartJS.cart);
        $.each(CartJS.cart.items, function(index, item) {

            if(item.product_type == 'hair') {
                hair_price += (item.quantity * item.price);
            }

            if(item.product_type == 'insurance') {
                insurance_id = item.product_id;
                insurance = item;
            }

        });

        if(cart.product_type == 'hair') {
            console.log('also here');
            console.log(cart);
            hair_price += cart.price;
        }

    }

    if(hair_price == 0 || insurance_id == 0) {
        $('.sm--cart-disable').removeClass('sm--loading');
        console.log('no insurance');
        return;
    }

    console.log(parseInt(hair_price * insurance_percentage));
    console.log(insurance.final_price);

    if(parseInt(hair_price * insurance_percentage) == insurance.final_price) {
        $('.sm--cart-disable').removeClass('sm--loading');
        console.log('do nothing');
        return;
    }

    var insurance_price = (hair_price * insurance_percentage) / 100;

    insurance_price = insurance_price.toString();
    insurance_price = insurance_price.slice(0, (insurance_price.indexOf("."))+3);

    $.ajax({
        type: 'POST',
        url: 'http://insurance.startupmasters.eu/api/edit-price',
        data: 'price=' + insurance_price + '&product_id=' + insurance_id,
        dataType: 'json',
        success: function(response) {

            CartJS.addItem(response.variants[0].id, 1, {}, {
                "success": function(data, textStatus, jqXHR) {
                    $('body').trigger('added.ajaxProduct');
                    $('.sm--cart-disable').removeClass('sm--loading');
                },
                "error": function(data, textStatus, jqXHR) {
                    $('.sm--cart-disable').removeClass('sm--loading');
                }
            });
        },
        error: function(XMLHttpRequest, textStatus) {
            $('.sm--cart-disable').removeClass('sm--loading');
        }
    });

}

function bindCartWaveSignature() {

    var $checkbox = $('#WaveSignature');
    var $order_note = $('#CartSpecialInstructions');

    $checkbox.on('change', function () {

        if(this.checked) {
            // Set a cookie
            setCookie('wave_signature', 'yes', 365);
            localStorage.setItem('wave_signature', 'yes');
            $order_note.text('I want to wave the delivery signature of my order.');
        } else {
            setCookie('wave_signature', 'no', 365);
            localStorage.setItem('wave_signature', 'no');
            $order_note.text('');
        }

    });

}

function bindRegularCartWaveSignature() {

    var $checkbox = jQuery('#WaveRegularSignature');
    var $order_note = jQuery('#CartRegularSpecialInstructions');

    $checkbox.on('change', function () {

        if(this.checked) {
            // Set a cookie
            setCookie('wave_signature', 'yes', 365);
            localStorage.setItem('wave_signature', 'yes');
            $order_note.text('I want to wave the delivery signature of my order.');
        } else {
            setCookie('wave_signature', 'no', 365);
            localStorage.setItem('wave_signature', 'no');
            $order_note.text('');
        }

    });

}

function bindCartInsurance() {

    // var $checkbox = $('#HairInsurance');

    $('body').on('change', '#HairInsurance', function () {

        if(this.checked) {

            console.log('add product');

            $('.sm--cart-disable').addClass('sm--loading');

            theme.cart.getCart().then(function(cart) {

                var insurance_percentage = 0.15;

                var hair_price = 0;
                $.each(cart.items, function(index, item) {

                    if(item.product_type == 'hair') {
                        hair_price += (item.quantity * item.price);
                    }

                });

                var insurance_price = (hair_price * insurance_percentage) / 100;

                insurance_price = insurance_price.toString();
                insurance_price = insurance_price.slice(0, (insurance_price.indexOf("."))+3);

                $.ajax({
                    type: 'POST',
                    url: 'http://insurance.startupmasters.eu/api/add-product',
                    data: 'price=' + insurance_price,
                    dataType: 'json',
                    success: function(response) {

                        CartJS.addItem(response.variants[0].id, 1, {}, {
                            "success": function(data, textStatus, jqXHR) {
                                $('body').trigger('added.ajaxProduct');
                                $('.sm--cart-disable').removeClass('sm--loading');
                            },
                            "error": function(data, textStatus, jqXHR) {
                                $('.sm--cart-disable').removeClass('sm--loading');
                            }
                        });

                    },
                    error: function(XMLHttpRequest, textStatus) {
                        $('.sm--cart-disable').removeClass('sm--loading');
                    }
                });

            });

        } else {

            $('.sm--cart-disable').addClass('sm--loading');

            // Get the insurance product
            var insurance_id = 0;
            var product_id = 0;
            $.each(CartJS.cart.items, function(index, item) {

                if(item.product_type == 'insurance') {
                    insurance_id = item.variant_id;
                    product_id = item.product_id;
                }

            });

            CartJS.updateItemById(insurance_id, 0, {}, {
                "success": function(data, textStatus, jqXHR) {
                    $('body').trigger('added.ajaxProduct');
                    $('.sm--cart-disable').removeClass('sm--loading');
                },
                "error": function(data, textStatus, jqXHR) {
                    $('.sm--cart-disable').removeClass('sm--loading');
                }
            });

            $.ajax({
                type: 'POST',
                url: 'http://insurance.startupmasters.eu/api/delete-product',
                data: 'product_id=' + product_id,
                dataType: 'json',
                success: function(response) {
                },
                error: function(XMLHttpRequest, textStatus) {
                }
            });

            console.log('remove product');

        }

    });

}

$(window).on('load', function() {

    $('.single-item').slick({
        infinite: true,
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
    });

    $('iframe[src*="https://www.youtube.com/embed/"]').addClass("youtube-iframe");

    $(".slick-arrow, .slick-dots li").on('click', function() {

        $('iframe[id^="slider-video"]').each( function() {
            $(this)[0].contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
        })

    });

    // Bind the wave signature checkbox in the cart
    bindCartWaveSignature();

    // Bind the wave signature checkbox in the regular cart
    bindRegularCartWaveSignature();

    // Bind the insurance checkbox in the cart
    bindCartInsurance();

    // Initialize auto-add product functionality
    bindAutoAddProduct();

    // Make an additional check 2 seconds later if the user had clicked the wave signature BEFORE the page load
    // setTimeout(() => {
    //
    //     var $checkbox = $('#WaveSignature');
    //     var $order_note = $('#CartSpecialInstructions');
    //
    //     if($checkbox.is(":checked")) {
    //         setCookie('wave_signature', 'yes', 365);
    //         $order_note.text('I want to wave the delivery signature of my order.');
    //     } else {
    //         setCookie('wave_signature', 'no', 365);
    //         $order_note.text('');
    //     }
    //
    // }, 2000);

    // Color swatch names
    updateColorName();

});

function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    let expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return null;
}

function updateColorName () {

    var $colorNameContainer = jQuery('.sm--product-current-color-wrapper .sm--variant-color');

    jQuery('.webyzeSwatches').on('click', '.swatchColor', function() {

        var $el = jQuery(this);

        var text = $el.data('name');
        if(text === 'HL-A - Cola') {
            text += '<br> Coarse texture'
            jQuery('.sm--african-explanation').show();
        } else {
            jQuery('.sm--african-explanation').hide();
        }

        $colorNameContainer.html(text);

    });

}

// Training collection filter handler
function handleCollectionTagFilter() {
    jQuery('.sm--collection-filter').on('change', function () {
        var $el = jQuery(this).children("option:selected");
        var url = $el.data('url');
        if (url) {
            window.location.href = url;
        }
    });
}

// Initialize collection filter on page load
jQuery(function () {
    handleCollectionTagFilter();
});

// Auto-add product Y when product X is added to cart
function bindAutoAddProduct() {
    // Product IDs (as strings for comparison - Shopify may return them as strings)
    var productXId = '8080851271759'; // Trigger product
    var productYId = '8080844456015'; // Auto-add product
    
    // Variant ID for product Y (set this to the variant ID, not the product ID)
    var productYVariantId = '44337158651983';
    
    // Flag to prevent infinite loops
    var isAddingProductY = false;
    
    // Function to get product Y's first available variant ID
    function getProductYVariantId() {
        return new Promise(function(resolve, reject) {
            // If variant ID is directly provided, use it
            if (productYVariantId) {
                resolve(productYVariantId);
                return;
            }
            
            // Try to get variant ID from cart items if product Y was previously added
            if (window.CartJS && window.CartJS.cart && window.CartJS.cart.items) {
                for (var i = 0; i < window.CartJS.cart.items.length; i++) {
                    if (String(window.CartJS.cart.items[i].product_id) == productYId) {
                        resolve(window.CartJS.cart.items[i].variant_id);
                        return;
                    }
                }
            }
            
            // Try to get product handle from the current page if we're on product Y's page
            var productHandle = null;
            if (window.BOLD && window.BOLD.common && window.BOLD.common.Shopify && window.BOLD.common.Shopify.handles) {
                var handle = window.BOLD.common.Shopify.handles[productYId];
                if (handle) {
                    productHandle = handle;
                }
            }
            
            // Try fetching product - first by handle if available, then by ID
            var fetchUrl = productHandle 
                ? window.Shopify.routes.root + 'products/' + productHandle + '.json'
                : window.Shopify.routes.root + 'products/' + productYId + '.json';
            
            fetch(fetchUrl)
                .then(function(response) {
                    if (response.ok) {
                        return response.json();
                    }
                    return response.text().then(function(text) {
                        throw new Error('Product fetch failed. Status: ' + response.status);
                    });
                })
                .then(function(productData) {
                    if (productData.product && productData.product.variants) {
                        // Even products without variants have at least one default variant
                        // Try to find an available variant first
                        for (var i = 0; i < productData.product.variants.length; i++) {
                            if (productData.product.variants[i].available) {
                                resolve(String(productData.product.variants[i].id));
                                return;
                            }
                        }
                        // If no available variant found, use the first variant anyway
                        if (productData.product.variants.length > 0) {
                            resolve(String(productData.product.variants[0].id));
                            return;
                        }
                    }
                    reject(new Error('No variants found'));
                })
                .catch(function(error) {
                    console.error('Could not fetch product Y variant ID. Please set productYVariantId in the code.');
                    reject(error);
                });
        });
    }
    
    // Listen for when a product is added to cart
    $('body').on('added.ajaxProduct', function() {
        // Prevent infinite loop if we're adding product Y
        if (isAddingProductY) {
            return;
        }
        
        // Small delay to ensure cart is fully updated
        setTimeout(function() {
            // Get current cart
            theme.cart.getCart().then(function(cart) {
                var hasProductX = false;
                var hasProductY = false;
                var productXItem = null;
                var productYVariantInCart = null;
                
                // Check if product X and Y are in cart
                if (cart.items && cart.items.length > 0) {
                    $.each(cart.items, function(index, item) {
                        var itemProductId = String(item.product_id);
                        
                        if (itemProductId == productXId) {
                            hasProductX = true;
                            productXItem = item; // Store Product X item details
                        }
                        if (itemProductId == productYId) {
                            hasProductY = true;
                            productYVariantInCart = item.variant_id;
                        }
                    });
                }
                
                // If product X is in cart and product Y is not, add product Y
                if (hasProductX && !hasProductY) {
                    isAddingProductY = true;
                    
                    // Store Product X details before removing it
                    var productXVariantId = productXItem.variant_id;
                    var productXQuantity = productXItem.quantity;
                    
                    // Remove Product X temporarily so we can add it back last (to appear first)
                    fetch(window.Shopify.routes.root + 'cart/change.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded'
                        },
                        body: 'id=' + productXVariantId + '&quantity=0'
                    })
                    .then(function(response) {
                        if (response.ok) {
                            return response.json();
                        }
                        throw new Error('Failed to remove product X');
                    })
                    .then(function() {
                        // Now add Product Y
                        var variantIdPromise;
                        if (productYVariantInCart) {
                            variantIdPromise = Promise.resolve(productYVariantInCart);
                        } else {
                            variantIdPromise = getProductYVariantId();
                        }
                        
                        return variantIdPromise.then(function(variantId) {
                            variantId = parseInt(variantId);
                            
                            // Add product Y to cart
                            var formData = {
                                'items': [{
                                    'id': variantId,
                                    'quantity': 1
                                }]
                            };
                            
                            return fetch(window.Shopify.routes.root + 'cart/add.js', {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json'
                                },
                                body: JSON.stringify(formData)
                            });
                        });
                    })
                    .then(function(response) {
                        if (response && response.ok) {
                            return response.json();
                        }
                        return response.text().then(function(text) {
                            throw new Error('Failed to add product Y to cart. Status: ' + response.status);
                        });
                    })
                    .then(function() {
                        // Re-add Product X (it will appear first since it's added last)
                        var formData = {
                            'items': [{
                                'id': parseInt(productXVariantId),
                                'quantity': productXQuantity
                            }]
                        };
                        
                        return fetch(window.Shopify.routes.root + 'cart/add.js', {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify(formData)
                        });
                    })
                    .then(function(response) {
                        if (response && response.ok) {
                            return response.json();
                        }
                        return response.text().then(function(text) {
                            throw new Error('Failed to re-add product X to cart. Status: ' + response.status);
                        });
                    })
                    .then(function(cart) {
                        // Trigger cart update
                        $('body').trigger('added.ajaxProduct');
                        isAddingProductY = false;
                    })
                    .catch(function(error) {
                        console.error('Error reordering cart items:', error);
                        // If something went wrong, try to restore Product X
                        if (productXItem) {
                            var formData = {
                                'items': [{
                                    'id': parseInt(productXVariantId),
                                    'quantity': productXQuantity
                                }]
                            };
                            fetch(window.Shopify.routes.root + 'cart/add.js', {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json'
                                },
                                body: JSON.stringify(formData)
                            });
                        }
                        isAddingProductY = false;
                    });
                }
            }).catch(function(error) {
                console.error('Error getting cart:', error);
            });
        }, 100); // 100ms delay to ensure cart is updated
    });
}

// Note: bindAutoAddProduct() is initialized in the window load event above